export default () => {
    return (
        <div className="page-content">
            <h1 className="tab-header">Contact Us</h1>
            <div>
                If you have any questions or problems we'd love to hear from you. The easiest/best way to do so is to call us at <a href="tel:+15187922364">(518) 792-2364</a>, but we also 
                periodically check our email <a href="mailto: kisieldent@gmail.com">kisieldent@gmail.com</a>.
                
                <br/><br/>

                We also appreciate hearing back from our patients — feel free to  
                <a href="https://www.facebook.com/pages/category/General-Dentist/Kisiel-Family-Dentistry-159636244067695/"> visit us on Facebook </a>
                or leave us a review by&nbsp;
                <a href="https://www.google.com/search?authuser=2&q=Dr.+Raymond+J.+Kisiel,+DDS&ludocid=12777026352487144466&lsig=AB86z5V2xwCqGHr_cpj4OkTTOUrQ#lrd=0x89dfcfded6d3c965:0xb1511dc5a1cd1c12,3,,,">clicking here </a> !<br/><br/>
            </div>

            <div className="contact-links">
                <a href="https://goo.gl/maps/ffc3SB6NDo3Tx5DX6" target="_blank">
                    Kisiel Family Dentistry<br/>
                    14 Baywood Dr.<br/>
                    Queensbury, NY<br/>
                    12804<br/><br/>
                </a>

                Phone: <a href="tel:+15187922364">(518) 792-2364</a><br/>
                Fax: (518) 745-8284<br/>
                Email: <a href="mailto: kisieldent@gmail.com">kisieldent@gmail.com</a>
            </div>
        </div>
    );
};